import {FetchBaseQueryError} from '@reduxjs/toolkit/query'
import {DateTime} from "luxon";

/**
 * Type predicate to narrow an unknown error to `FetchBaseQueryError`
 */
export function isFetchBaseQueryError(
    error: unknown
): error is FetchBaseQueryError {
    return typeof error === 'object' && error != null && 'status' in error
}

/**
 * Type predicate to narrow an unknown error to an object with a string 'message' property
 */
export function isErrorWithMessage(
    error: unknown
): error is { message: string } {
    return (
        typeof error === 'object' &&
        error != null &&
        'message' in error &&
        typeof (error as any).message === 'string'
    )
}

type AnnoMeseGiorno = {
    anno: number,
    mese: number,
    giorno: number,
}

export function annoMeseGiorno2DT(values: AnnoMeseGiorno[]) {
    const currentYear = DateTime.now().year;
    const dates: DateTime[] = [];
    for (const value of values) {
        dates.push(DateTime.fromObject({year: value.anno > 0 ? value.anno : currentYear, month: value.mese, day: value.giorno, hour: 0, minute: 0}))
    }
    return dates;
}